import React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import './index.css';
import App from "./App";
import { initPostHog } from "./lib/posthog";

initPostHog();

// createBrowserRouter (data router) is used instead of BrowserRouter because:
// 1. It is the React Router v6.4+ recommended approach for all new projects.
// 2. It unlocks data router-only APIs such as useBlocker (used for unsaved-changes
//    navigation guards in the custom dashboard builder).
//
// The wildcard path: "*" delegates all route matching to App.tsx, so existing
// <Routes>/<Route> definitions, useNavigate, useParams, etc. are unaffected.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
